import { render, staticRenderFns } from "./CompanyWorkspaceHeader.vue?vue&type=template&id=ff97e6c8&scoped=true"
import script from "./CompanyWorkspaceHeader.vue?vue&type=script&lang=js"
export * from "./CompanyWorkspaceHeader.vue?vue&type=script&lang=js"
import style0 from "./CompanyWorkspaceHeader.vue?vue&type=style&index=0&id=ff97e6c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff97e6c8",
  null
  
)

export default component.exports